import api from '@/api'

class UserService {

  static changeAddressSubscription(data) {
    return api({
      url: 'change-address-subscription',
      data,
      method: 'post'
    })
  }

	static getUserAddress() {
		return api({
			url: 'user-address',
		})
  }

  static getActiveSubscription() {
    return api({
      url: 'subscription-user'
    })
  }

  static cancelSubscription() {
    return api({
      method: 'post',
      url: 'cancel-subscription'
    })
  }

  static billingRequest(data) {
    return api({
      method: 'post',
      url: 'billing-request',
      data
    })
  }

  static getOrders(page) {
    return api({
      method: 'get',
      url: 'orders-by-user',
      params: { page }
    })
  }

  static getOrder(order_id, user_id) {
    return api({
      method: 'get',
      url: `order-detail`,
      params: { order_id, user_id }
    })
  }

  static getOrderLalamove(lalamove_id) {
    return api({
      method: 'get',
      url: `user-order-detail-lalamove`,
      params: { ref: lalamove_id }
    })
  }

  static getDriverUbication(lalamove_id, driver_id) {
    return api({
      method: 'get',
      url: `user-ubication-driver-lalamove`,
      params: { order_id: lalamove_id, driver_id }
    })
  }

  static updateProfile(data) {
    return api({
      method: 'put',
      url: 'update-profile',
      data
    })
  }

}

export default UserService
